// extracted by mini-css-extract-plugin
export var mentors = "mentors-list-module--mentors--OwxaP";
export var wrapper = "mentors-list-module--wrapper--qJIh9";